import React from 'react'
import ReactDOM from 'react-dom'
import '@fontsource/roboto/300'
import '@fontsource/roboto/400'
import '@fontsource/roboto/500'
import '@fontsource/roboto/700'
import '@fontsource/cambay/400'
import '@fontsource/cambay/700'
import 'material-icons/iconfont/outlined.css'
import './shared/assets/styles/global.css'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))

const errorsToWarn = ['Warning:']
const oldConsError = console.error

console.error = function (...args) {
  let toWarn = typeof args[0] === 'string' && errorsToWarn.some(s => args[0].startsWith(s))
  toWarn ? console.warn(...args) : oldConsError(...args)
}
